module.exports = __webpack_public_path__ + "img/passport.a96166eb.svg";